import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search } from 'lucide-react';

const CreditCustomerDialog = ({
  open,
  onOpenChange,
  searchQuery,
  setSearchQuery,
  searchResults,
  onSearchCustomers,
  onSelectGuest,
  onSelectCreditCustomer
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Select Customer for Credit</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <Input
              placeholder="Search by name, phone, company..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.length >= 2) {
                  onSearchCustomers(e.target.value);
                }
              }}
              className="pl-10"
              data-testid="credit-search-input"
            />
          </div>

          <div className="max-h-60 overflow-y-auto space-y-2">
            {searchResults.guests?.map(guest => (
              <button
                key={guest.id}
                className="w-full p-3 text-left border rounded-lg hover:bg-gray-50 flex items-center justify-between"
                onClick={() => onSelectGuest(guest)}
                data-testid={`credit-guest-${guest.id}`}
              >
                <div>
                  <p className="font-medium">{guest.name}</p>
                  <p className="text-sm text-gray-500">{guest.phone}</p>
                </div>
                {guest.has_credit_account && (
                  <Badge variant="outline" className="text-amber-600 border-amber-200">
                    ₹{guest.credit_balance?.toLocaleString() || 0}
                  </Badge>
                )}
              </button>
            ))}
            
            {searchResults.credit_customers?.map(customer => (
              <button
                key={customer.id}
                className="w-full p-3 text-left border rounded-lg hover:bg-gray-50 flex items-center justify-between"
                onClick={() => onSelectCreditCustomer(customer)}
                data-testid={`credit-customer-${customer.id}`}
              >
                <div>
                  <p className="font-medium">{customer.name}</p>
                  <p className="text-sm text-gray-500">{customer.phone} {customer.company && `• ${customer.company}`}</p>
                </div>
                <Badge variant="outline" className="text-amber-600 border-amber-200">
                  ₹{customer.credit_account?.current_balance?.toLocaleString() || 0}
                </Badge>
              </button>
            ))}
          </div>

          {searchQuery.length >= 2 && 
           searchResults.guests?.length === 0 && 
           searchResults.credit_customers?.length === 0 && (
            <p className="text-center text-gray-500 py-4">No customers found</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreditCustomerDialog;
